
import { Component, Vue } from 'vue-property-decorator';
import { UserBaseInfoInterface, UserRepoInterface } from '@/services/Users/Interfaces';
import { DataTableHeader } from 'vuetify';
import Themeable from 'vuetify/lib/mixins/themeable';
import { ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';
import user from '@/Store/modules/user';

interface DossierTableInterface {
  id: string,
  name: string,
  email: string,
}

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'userRepository',
    'profileRepository',
  ],
})
export default class AllDossiers extends Vue {
  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Name', value: 'name' },
    { text: 'Email', value: 'email' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private userRepository!: UserRepoInterface;
  private profileRepository!: ProfileRepositoryInterface;

  private dossiers: DossierTableInterface[] = [];
  private search: string = '';

  private loading: boolean = true;

  public async created(): Promise<void> {
    await this.fetchDossiers();
    this.loading = false;
  }

  private async fetchDossiers(): Promise<void> {
    const users = await this.userRepository.getQaUsers();
    const profiles = await this.profileRepository.getBaseProfileDataByUsersIds(users.map((userData) => userData.id));

    profiles.forEach((profile) => {
      const usersIndex = users.findIndex((userData) => userData.id === profile.userId);
      if (usersIndex !== -1) {
        this.dossiers.push({
          id: profile.userId,
          email: users[usersIndex].email,
          name: `${profile.firstName} ${profile.lastName}`,
        });
      }
    });
  }

  private viewUser(userId: string): void {
    this.$router.push({ path: `dossiers/${userId}` });
  }
}
